import { render, staticRenderFns } from "./GenerateNomor.vue?vue&type=template&id=36a57f9d"
import script from "./GenerateNomor.vue?vue&type=script&lang=js"
export * from "./GenerateNomor.vue?vue&type=script&lang=js"
import style0 from "./GenerateNomor.vue?vue&type=style&index=0&id=36a57f9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports